<template>
  <div class="pages">
    <img src="/static/product/banner-cp@3x.png" class="tImg" />
    <div class="b_pic_text">
      {{ $t('main.productCenter') }}
    </div>
    <div
      id="process"
      class="process"
      :class="{ isFixed: searchBarFixed }"
    >
      <div
        v-for="(item, index) in steps"
        :key="item.id"
        class="step"
        :class="{ isActived: actived === index }"
        @click="handleClickTab(item)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="content" id="content">
      <div v-if="steps[actived]">
        <div
          class="box"
          v-for="(item, index) in steps[actived].child"
          :key="index"
        >
          <div class="title facab">
            <div class="p-t">{{ item.name }}</div>
            <div class="r-t" @click="goToMore(item)">{{ $t('main.viewMore') }} ></div>
          </div>
          <div class="product_box">
            <div class="pBox" v-for="(v, ind) in handleArr(item.child)" :key="v.id" @click="goDetail(v)">
              <div v-if="ind < 9">

                <div class="pImg img_replace">
                  <img v-if="v.image" :src="v.image" class="pImg" />
                  <div  v-else>{{ $t('main.nopic') }}</div>
                </div>
                <div class="pText nowap">{{ v.name }}</div>
                <div class="pPrice">{{ v.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      cat_id: null, // 栏目id
      steps: [], // 子导航
      searchBarFixed: false,
      actived: 0,
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    init() {
      if (localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        this.steps = JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo")));
        let nowProductTypeIndex = this.steps.findIndex(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });
        this.actived = nowProductTypeIndex > -1 ? nowProductTypeIndex : 0;
        this.$nextTick(() => {
          setTimeout(() => {
            this.jump(this.actived);
          }, 500);
        });

      }
    },
    // 切割数组
    handleArr(data) {
      let res = _.cloneDeep(data);
      res.splice(9);
      return res;
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    handleClickTab(item) {
      this.$router.push({
        path: this.getRoutesPath(item['list_template'], item['identification'], item['id'])
      });
    },
    jump () {
      let navH = document.getElementsByClassName("header")[0].offsetHeight;
      let imgH = document.getElementsByClassName("tImg")[0].offsetHeight;
      let processH = document.getElementById("process").offsetHeight;
      window.scrollTo({
        top: navH + imgH + processH - 30,
        behavior: "smooth"
      });
    },
    goDetail(item) {
      this.$router.push({
        path: this.getRoutesPath('detail_product', item['identification'], item['id'])
      });
    },
    goToMore(item) {
      this.$router.push({
        path: this.getRoutesPath('category_product_more', item['identification'], item['id'])
      });
    },
    handleScroll() {
      this.scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      if (this.scrollTop >= document.getElementById("content").offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          res.push({
            ...item,
            child: null
          });
          if(item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .isFixed {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
  }

  .process {
    height: 30px;
    font-size: 1.1428rem;
    line-height: 30px;
    background-color: #f2f2f2;

    .step {
      color: #FFF;
      float: left;
      padding: 0 20px;
      margin: 0 20px 0 0;
      min-width: 100px;
      text-align: center;
      border-radius: 0.2rem;
      cursor: pointer;
      position: relative;
      background: #B8B0D4;
      &:hover {
        background: #635796;
        color: #FFF;

        &:before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: calc(50% - 2.5px);
          width: 10px;
          height: 10px;
          background: #635796;
          transform: rotate(45deg);
        }
      }
      &:not(:last-child):after {
        content: '';
        float: right;
        width: 2px;
        height: 20px;
        background: #635796;
        right: -10px;
        top: 5px;
        position: absolute;
      }
    }

    .isActived {
      background: #635796;

      &:before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: calc(50% - 2.5px);
        width: 10px;
        height: 10px;
        background: #635796;
        transform: rotate(45deg);
      }
    }
  }

  .content {
    .box {
      margin: 3.25rem -1rem 0;

      .title {
        margin: 0 1rem;
        padding-bottom: 1.25rem;
        border-bottom: 1px solid #cccccc;

        .p-t {
          font-size: 1.875rem;
          font-family: YouSheBiaoTiHei,serif;
          font-weight: 400;
          color: #666666;
        }

        .r-t {
          font-size: 1.1428rem;
          color: #635796;
          cursor: pointer;
          line-height: 2.25rem;
        }
      }

      .product_box {
        display: flex;
        flex-wrap: wrap;

        &:hover {
          cursor: pointer;
        }

        .special {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          color: #fff;
          font-weight: bold;
          box-sizing: border-box;
          padding: 2rem;
          width: calc(50% - 2rem);
          height: 19.5rem;
          margin: 2.5rem 1rem 0 1rem;
          border-radius: 3rem;
          background-color: red;
        }

        .pBox {
          width: calc(25% - 2rem);
          margin: 1rem 1rem;

          .pImg {
            width: 100%;
            min-height: 110px;
            border-radius: 1rem;
          }
          .img_replace {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px dashed #666666;
          }

          .pText {
            color: #1a1a1a;
            margin-top: 1.25rem;
            text-align: center;
          }

          .pPrice {
            font-size: 1.1428rem;
            font-weight: bold;
            color: #cd3222;
            margin-top: 1.125rem;
          }
        }

        .find_more {
          position: relative;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: calc(25% - 2rem);
          height: 13.125rem;
          margin: 2.5rem 1rem;
          //background-color: gray;
          border: 1px dashed #666;
          border-radius: 3rem;

          &::after {
            content: ">>";
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
          }

          .pText {
            color: #1a1a1a;
            margin-bottom: -3rem;
          }
        }
      };
    }
  }
  @media screen and (max-width: 1400px) {
    .process {
      padding: 0 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .process {
      padding: 0 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .process {
      padding: 0 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }
}
</style>
